import React, { Component } from 'react';
import BsyIconBtn from "../BsyIconBtn";
import BsyTableList from "../BsyTableList";
import BsyDialog from "../BsyDialog";
import AlertBatchImport from "./AlertBatchImport";
import emptyImg from "../../images/img_wujuese.png"
import { BsyUtils } from "../../utils/Utils";
import BsySearchInput from '../BsySearchInput';

class BsyRoleCont extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userCont: {},
            role: props.role,
            hasCount: true,
            limit: 20,
            skip: 0,
            filter: "",
            roleSync: props.roleSync,
            checkList: [],
            checkListDetail:[]
        }
        this.searchValue = null;
    }

    skipChange = (val) => {
        this.setState({ skip: val }, () => {
            this.RefreshList()
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log(prevProps, prevState, snapshot)
        if (prevProps.role._id) {
            if (prevProps.role._id !== this.props.role._id) {
                this.setState({ role: prevProps.role })
            }
        } else {
            if (this.props.role._id) {
                this.setState({ role: this.props.role })
            }
        }

    }

    listLimitChange = (val) => {
        this.setState({ limit: val }, () => {
            this.RefreshList()
        })
    }

    listFilterChange = (val) => {
        this.setState({ filter: val }, () => {
            this.RefreshList()
        })
    }

    deptRefresh = (val) => {
        this.setState({ deptId: val }, () => {
            this.RefreshList()
        })
    }

    roleRefresh = (val) => {
        this.setState({ role: val }, () => {
            this.RefreshList()
        })
    }

    componentDidMount() {
        this.RefreshList();
        this.props.getRoleCont && this.props.getRoleCont(this)
    }

    RefreshList = () => {
        const { limit, skip, role } = this.state
        if (role.role_id === undefined) {
            return;
        }
        let searchValue = "";
        if (this.searchValue) {
            searchValue = this.searchValue.getValue()
        }
        React.axios(`/corp/role/${role.role_id}/list_member`, {
            corpId: window.FX.Utils.getCurrentCorp(),
            hasConTactInfo: true,
            hasCount: true,
            limit: limit,
            skip: skip * limit,
            filter: searchValue,
        }).then(res => {
            this.setState({ userCont: res.data })
        }).catch(res => {

        })
    }

    inviteUser = () => {
        const { role } = this.state
        const _this = this;
        var e = new window.FX.ConfirmDialog({
            title: React.language("widget.user.listTitle"),
            height: 586,
            width: 956,
            contentWidget: {
                rowSize: [450],
                colSize: [926],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    roleEnable: 0,
                    hasDock: false,
                    departmentEnable: !1,
                    hasTeamManageBtn: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1
                }]]
            },
            onOk: function () {
                var t = e.getWidgetByName("memberSelect").getValue();
                window.FX.Utils.ajax({
                    url: "/corp/role/" + role.role_id + "/set_member",//FX.Utils.getApi(FX.API.corp.set_member, i.currentRole.role_id),
                    data: {
                        corpId: window.FX.Utils.getCurrentCorp(),
                        add: t,
                    }
                }, function () {
                    _this.RefreshList()
                    e.close()
                }, function (e) {
                    window.FX.Vip.showUpgradeTip(e.responseJSON)
                })
                return !1
            }
        });
        e.show()
    }

    getPopupValue = (val) => {
        this.value = val;
    }

    alertExport = () => {
        BsyDialog({
            title: React.language("batch.Import"),
            height: 440,
            width: 720,
            noFooter: true,
            onContentCreate: () => {
                return <AlertBatchImport
                    role={this.state.role}
                    roleRefresh={this.roleRefresh}
                    getValue={this.getPopupValue} />
            },
            onOk: () => {
                if (!this.value) {
                    return false
                }
            }
        })
    }

    removeRoleItem = (e) => {
        const { role, checkList } = this.state
        const _this = this;
        window.FX.Msg.alert({
            title: React.language("role.removeMember.confirm"),
            msg: React.language("role.removeMember.tip"),
            type: "warning",
            onOk: function () {
                window.FX.Utils.ajax({
                    url: "/corp/role/" + role.role_id + "/set_member",//FX.Utils.getApi(FX.API.corp.set_member, t.currentRole.role_id),
                    data: {
                        corpId: window.FX.Utils.getCurrentCorp(),
                        remove: checkList
                    }
                }, function () {
                    _this.RefreshList()
                }, function (e) {
                    window.FX.Vip.showUpgradeTip(e.responseJSON)
                })
            }
        })
    }

    getTableValue = (rel) => {
        this.tableValue = rel
    }

    getSearchValue = (ref) => {
        this.searchValue = ref
    }

    onSearch = () => {
        this.setState({ skip: 0 }, () => {
            this.RefreshList()
        })
    }

    closeCheckMenu = () =>{
        this.setState({checkList: [], checkListDetail: [], checked: false})
    }

    onCheck = (e) =>{
        this.setState({checkList: e.checkList, checkListDetail: e.checkListDetail, checked: e.checked})
    }

    render() {
        let { userCont, limit, skip, role, roleSync, checkList, checkListDetail, checked } = this.state;
        const { emptyRole, createRoleGroup } = this.props;

        let list = [{
            width: 295,
            key: "account",
            value: React.language("receipt.account")
        }, {
            width: 295,
            key: "nickname",
            value: React.language("name")
        }, {
            width: 295,
            key: "department",
            value: React.language("department"),
            onGetText: (val) => {

                if (!val) {
                    return '';
                }
                return val.join('、')

            }
        }, {
            width: 20,
            key: "del",
            value: ""
        }]



        return (
            <div className="user">
                <div className="user-content">
                    {
                        emptyRole ? <>
                          <div className="userTitle" style={
                              BsyUtils.isSubAdmin() ? { 'border-bottom-color': 'transparent' } : {}
                          }>
                              <div className="leftUserCont">
                                  <div className="title">
                                      {role.name}
                                  </div>
                              </div>
                          </div>
                          {
                              roleSync ? '' :
                                checkList.length <= 0 ? <div className="userFunBtn">
                                    <div className="btnCont">
                                        <BsyIconBtn
                                          text={React.language('member.add')}
                                          iconName="icon-bsy-iconquanbuchengyuan"
                                          type="blue"
                                          click={this.inviteUser}
                                          mode={window.mode}
                                        />
                                        <BsyIconBtn
                                          text={React.language('batch.Import')}
                                          iconName="icon-import"
                                          type="white"
                                          hoverType="borderBlue"
                                          click={this.alertExport}
                                          mode={window.mode}
                                        />
                                    </div>
                                    <div className="searchCont">
                                        <BsySearchInput
                                          placeholder={React.language('member.search1')}
                                          styleInput={{
                                              width: '200px',
                                              height: '32px',
                                              lineHeight: '30px'
                                          }}
                                          getValue={this.getSearchValue}
                                          onSearch={this.onSearch}
                                          type={window.mode}
                                          // iconName="icon-bsy-reportmenu-0"
                                        />
                                    </div>
                                </div> : <div className="check-menu">
                                    <div className="close-btn" onClick={this.closeCheckMenu}>
                                        <i className="icon-close-large"></i>
                                    </div>
                                    <div className="total-cont">
                                <span className="checked-num-wrapper">
                                    <span className="checked-title">{React.language('msg.target.set.selected')}</span>
                                    <span className="checked-num">{checkList.length}</span>
                                    /{userCont.users.length}
                                </span>
                                    </div>
                                    {
                                        <div className="set-btn" onClick={this.removeRoleItem}>
                                            <i className="icon-batch-delete"></i>
                                            <span>{React.language("bulk.removal")}</span>
                                        </div>
                                    }

                                </div>
                          }
                          {userCont.users &&
                            <BsyTableList
                              getValue={this.getTableValue}
                              limit={limit}
                              skip={skip}
                              styleType={window.mode}
                              skipChange={this.skipChange}
                              listLimitChange={this.listLimitChange}
                              deptRefresh={this.deptRefresh}
                              listFilterChange={this.listFilterChange}
                              noMenu={true}
                              hasDelBtn={BsyUtils.isSubAdmin() ? roleSync ? false : true : false}
                              userCont={userCont}
                              count={userCont.count}
                              hasTurnPage={!!userCont.count}
                              noDarg={true}
                              list={list}
                              checkList={checkList}
                              checkListDetail={checkListDetail}
                              checked={checked}
                              onRowClick={(e, node) => {
                                  if (e.target.classList[0] !== "icon-trasho") {
                                      return
                                  }
                                  this.removeRoleItem([node._id])
                              }}
                              onCheck={(e)=>{
                                  this.onCheck(e)
                              }}
                            />}
                      </>
                          :
                        <div className="roleContentEmpty">
                          <div className="emptyCont">
                              <img src={emptyImg} alt="" />
                              <p>{roleSync ? React.language('role.empty.tip1') : React.language('role.empty.tip')}</p>
                              {
                                  roleSync ? '' : <BsyIconBtn
                                    text={React.language('create.role')}
                                    type="blue"
                                    click={createRoleGroup}
                                    mode={window.mode}
                                  />
                              }

                          </div>
                      </div>
                    }
                </div>

            </div>
        );
    }
}

export default BsyRoleCont;